import { Row as StandaloneRow } from '@/components/Row';
import { getSite } from '@/utils/getSite';

export const Row: typeof StandaloneRow = ({ options, content, ...props }) => {
  if (getSite() === 'residence') {
    return null;
  }

  return (
    <StandaloneRow
      content={<div className="max-w-full resize-x overflow-x-hidden">{content}</div>}
      options={{
        className: 'mx-0 max-w-full flex flex-col',
        ...options,
      }}
      {...props}
    />
  );
};
